interface LogoProps {
  size?: number;
  showWordmark?: boolean;
  className?: string;
}

/**
 * Clean Alkis wordmark. The old multi-drink glyph was too noisy in the
 * sidebar at small sizes, so the app chrome uses a simple monogram mark.
 */
export function Logo({ size = 32, showWordmark = true, className }: LogoProps) {
  return (
    <span className={`inline-flex items-center gap-3 ${className ?? ''}`}>
      <span
        aria-hidden
        className="grid shrink-0 place-items-center rounded-md border border-candle/35 bg-candle/10 font-serif font-semibold text-candle shadow-glow"
        style={{ width: size, height: size, fontSize: Math.max(15, size * 0.48) }}
      >
        A
      </span>
      {showWordmark && (
        <span className="font-serif text-xl font-semibold tracking-[0.12em] text-parchment">
          ALKIS
        </span>
      )}
    </span>
  );
}
